module.exports = __webpack_public_path__ + "img/ada-badge-2022_jp.24f6f57.svg";